import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { getAgedReceivables } from "../../../services/tenantUserAdminService";
import { TC } from "../../../tokens/text";
import { ResponsiveContainer, BarChart, Bar, XAxis, Tooltip } from "recharts";

export default function AgedReceivablesWidget({ tenantId }) {
  const [loading, setLoading] = useState(true);
  const [buckets, setBuckets] = useState([]);

  useEffect(() => {
    const demoMode = typeof window !== 'undefined' && (window.__LEDGERHUB_DEMO || new URLSearchParams(window.location.search).get('demo') === 'true');
    if (demoMode) {
      setBuckets([
        { label: "0-30 days", amount: 1200 },
        { label: "31-60 days", amount: 800 },
        { label: "61-90 days", amount: 300 },
        { label: "90+ days", amount: 150 },
      ]);
      setLoading(false);
      return;
    }
    if (!tenantId) return;
    setLoading(true);
    getAgedReceivables(tenantId)
      .then((res) => setBuckets((res.buckets || []).map(b => ({ label: b.label, amount: Number(b.amount || 0) })) ))
      .catch(() => setBuckets([]))
      .finally(() => setLoading(false));
  }, [tenantId]);

  if (loading) return <VuiBox display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress size={24} /></VuiBox>;
  if (!buckets.length) return <VuiBox p={2}><VuiTypography color="text">No outstanding invoices.</VuiTypography></VuiBox>;

  const total = buckets.reduce((s, b) => s + b.amount, 0);

  return (
    <VuiBox p={1} display="flex" flexDirection="column" gap={1} height="100%">
      <VuiBox display="flex" justifyContent="space-between" alignItems="center">
        <VuiTypography sx={{ color: TC.secondary }}>Aged Receivables</VuiTypography>
        <VuiTypography sx={{ color: TC.primary, fontWeight: 700 }}>£{total.toLocaleString()}</VuiTypography>
      </VuiBox>
      <VuiBox sx={{ flex: 1, minHeight: 0 }}>
        <ResponsiveContainer width="100%" height={120}>
          <BarChart data={buckets} margin={{ top: 6, right: 8, left: 0, bottom: 0 }}>
            <XAxis dataKey="label" />
            <Tooltip formatter={(v)=>`£${v}`} />
            <Bar dataKey="amount" fill="#ff9800" />
          </BarChart>
        </ResponsiveContainer>
      </VuiBox>
    </VuiBox>
  );
}

